<template>
	<div>
		<div class="title">
			<div style="margin-left: 10px;font-weight: bold;margin-top: 10px;">
				<a-icon type="bars" />
				&nbsp;订单列表
			</div>
			<div>
				<span class="search">
					订单号：<a-input v-model="orderSn" placeholder="请输入订单号" />
				</span>
				<span class="search">
					收货人手机号：<a-input v-model="phone" placeholder="请输入收货人手机号" />
				</span>
				<span class="search">
					订单时间：
					<a-date-picker v-model="createTime" placeholder="请输入订单时间">
						<template slot="renderExtraFooter">
							请输入订单时间
						</template>
					</a-date-picker>
				</span>
				<span class="search">
					订单状态：
					<a-select
					    labelInValue
					    v-model="orderKey"
					    style="width: 120px"
					    @change="handleChange"
					  >
					    <a-select-option value="all">全部</a-select-option>
					    <a-select-option value="1">待付款</a-select-option>
						<a-select-option value="2">待发货</a-select-option>
						<a-select-option value="3">已发货</a-select-option>
						<a-select-option value="4">待评价</a-select-option>
						<a-select-option value="5">交易成功</a-select-option>
						<a-select-option value="6">交易关闭</a-select-option>
					  </a-select>
				</span>
				<span class="search">
					<a-button type="primary" @click="searchHandle" icon="search">搜索</a-button>
					<a-divider type="vertical" />
					<a-button @click="resetHandle" icon="reload">重置</a-button>
				</span>
			</div>
		</div>
		
		<div class="table">
			<a-table :columns="columns" :dataSource="data" :pagination="pagination" @change="handleTableChange">
				<a slot="nickName" slot-scope="text,record">
				{{record.nickName}} {{record.tel}}
				</a>
				
				<span slot="remark" slot-scope="text,record">
					<span v-if="text != undefined && text != ''">{{text}}</span>
					<span v-else style="color: #aaa0a0;">暂无订单备注</span>
				</span>
				<span slot="payStatus" slot-scope="text">
					<a-tag v-if="text == 0" color='orange'><a-badge status="success" />未支付</a-tag>
					<a-tag v-if="text == 1" color='green'><a-badge status="success" />支付成功</a-tag>
					<a-tag v-if="text == 2" color='#aa0000'><a-badge status="success" />退款订单</a-tag>
				</span>
			    <span slot="orderStatus" slot-scope="text">
					<a-tag v-if="text == 1" color='cyan'><a-badge status="success" />待付款</a-tag>
					<a-tag v-if="text == 2" color='red'><a-badge status="success" />待发货</a-tag>
					<a-tag v-if="text == 3" color='purple'><a-badge status="success" />已发货</a-tag>
					<a-tag v-if="text == 4" color='blue'><a-badge status="success" />待评价</a-tag>
					<a-tag v-if="text == 5" color='green'><a-badge status="success" />交易成功</a-tag>
					<a-tag v-if="text == 6" color='#ff5500'><a-badge status="success" />交易关闭</a-tag>
			    </span>
			    <span slot="operation" slot-scope="text, record">
					<a-button @click="orderDetail(record.orderId)">查看订单</a-button>
					<a-divider type="vertical" />
					<a-button v-if="record.orderStatus == 1" @click="showMoneyModle(record.orderMoney,record.orderId)" type="primary" icon="pay-circle">修改价格</a-button>
					<a-button v-if="record.orderStatus == 6" @click="showDeleteConfirm(record.orderSn)" type="danger">删除订单</a-button>
					<a-button v-if="record.orderStatus == 2" @click="shipments(record)" type="primary">订单发货</a-button>
					<a-button v-if="record.orderStatus == 3 || record.orderStatus == 4 || record.orderStatus == 5" @click="synQuery(record.orderId)">订单跟踪</a-button>
			    </span>
			  </a-table>
		</div>
		
		<a-modal width="1400px" okText="确认发货" v-model="visible" @ok="handleOk">
			<template slot="title">
				订单发货 
			</template>
			<a-table :pagination="false" :columns="shipmentsColumn" :dataSource="shipmentsData" bordered>
				<template slot="shipModeTitle">
					订单发货 
					<span>
						<a-tooltip placement="left" title="点击查看支持的物流公司" >
							<a-icon @click="shipModeTable" style="font-size: 17px;color: red;" type="info-circle" theme='twoTone'/>
						</a-tooltip>
					</span>
				</template>
			    <template slot="shipMode" slot-scope="text">
			      <a-auto-complete
					:dataSource="express"
					@search="onSearch"
					v-model="shipmentsInfo"
					style="width: 200px"
					placeholder="请选择配送方式"
				/>
				</template>
				<template slot="logisticsSn" slot-scope="text">
					<a-input 
					v-model="shipmentsSn"
					placeholder="请输入物流订单号" />
			    </template>
			</a-table>
		</a-modal>
		<a-modal width="400px" okText="确认修改" cancelText="取消" v-model="moneyVisible" @ok="moneyHandleOk">
			<template slot="title">
				修改价格 
			</template>
			订单金额(元)：
			<a-input-number
				placeholder="市场价格"
				:min="0.02"
				:max="9999999"
				style=" margin-right: 8px;width: 120px;"
				v-model="orderMoney"
				:precision="2"
				:formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
				:parser="value => value.replace(/\￥\s?|(,*)/g, '')"	
			/>
		</a-modal>
		<a-modal width="1400px" okText="关闭"  v-model="SynVisible" @ok="SynVisible = false">
			<a-list itemLayout="horizontal" :dataSource="datas">
			    <a-list-item slot="renderItem" slot-scope="item, index">
					<a-list-item-meta
						:description="item.context"
					>
			        <a slot="title">{{ item.time }}</a>
			        <a-avatar
			          slot="avatar"
			          src="http://cdn.diqwl.com/store_banner_%E6%8B%89%E8%B4%A7%E8%BD%A6.png"
			        />
			      </a-list-item-meta>
			    </a-list-item>
			  </a-list>
		</a-modal>
	</div>
</template>
<script>
import api from '../../../api/Api.js';
import express from './express.js'

const columns = [
  {
    title: '编号',
    dataIndex: 'orderId',
    key: 'orderId',
  },
  {
    title: '订单号',
	width:'350px',
    dataIndex: 'orderSn',
    key: 'orderSn',
  },
  {
    title: '提交时间',
  	width:'200px',
    dataIndex: 'createTime',
    key: 'createTime',
  },
  {
    dataIndex: 'nickName',
    key: 'nickName',
	width:'200px',
	title: '收货用户',
    scopedSlots: { customRender: 'nickName' }
  },
  {
    dataIndex: 'remark',
    key: 'remark',
	width:'200px',
  	title: '订单备注',
	scopedSlots: { customRender: 'remark' }
  },
  {
    title: '支付状态',
    dataIndex: 'payStatus',
    key: 'payStatus',
  	scopedSlots: { customRender: 'payStatus' }
  },
  {
    title: '订单状态',
    dataIndex: 'orderStatus',
    key: 'orderStatus',
	scopedSlots: { customRender: 'orderStatus' }
  },
  {
    title: '订单金额(元)',
    key: 'orderMoney',
    dataIndex: 'orderMoney'
  },
  { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
];

const shipmentsColumn = [
  {
    title: '订单号',
	width:'25%',
    dataIndex: 'orderSn',
    key: 'orderSn',
  },
  {
    title: '收货人',
  	width:'7%',
    dataIndex: 'nickName',
    key: 'nickName',
  },
  {
    dataIndex: 'tel',
    key: 'tel',
	width:'13%',
	title: '手机号码',
  },
  {
    title: '收货地址',
	width:'20%',
    dataIndex: 'address',
    key: 'address'
  },
  {
	width:'15%',
    dataIndex: 'shipMode',
    key: 'shipMode',
	scopedSlots: { customRender: 'shipMode',title: 'shipModeTitle' }
  },
  {
    title: '物流单号',
	width:'20%',
    key: 'logisticsSn',
    dataIndex: 'logisticsSn',
	scopedSlots: { customRender: 'logisticsSn' }
  }
];

export default {
	data() {
		return {
			data:[],
			datas:[],
			shipmentsData:[],
			columns,
			shipmentsColumn,
			page:0,
			pagination: { current: 0, pageSize: 10, total: 55 },
			orderSn: '',
			phone: '',
			orderKey:{ key: 'all' },
			orderStatus: 'all',
			createTime: undefined,
			visible: false,
			SynVisible: false,
			express: express.data2,
			text: '',
			shipmentsInfo:'',
			shipmentsSn:'',
			shipmentsOrderId:0,
			moneyVisible:false,
			orderMoney:0,
			orderId:0
		};
	},
	mounted() {
		this.getOrderListInfo();
	},
	methods: {
		getOrderListInfo(){
			const that = this;
			let url = 'api/store/v1/admin/order/orderList';
			let param = {
				page : this.page,
				orderSn: this.orderSn,
				phone: this.phone,
				orderStatus: this.orderStatus,
				createTime: this.createTime == undefined ? '' : this.createTime
			};
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					console.log(res.data);
					this.data = res.data.data;
					that.pagination.total = res.data.maxCount;
					this.data.forEach((item, index, array) => {
						item.key = index;
						item.orderMoney = item.orderMoney + '';
						var arr = item.orderMoney.split('');
						var orderMoney = '';
						for (var i = 0; i < arr.length; i++) {
							orderMoney += arr[i];
							if (i == arr.length - 3) {
								orderMoney += '.';
							}
						}
						item.orderMoney = orderMoney;
					});
				} else {
					this.$message.error(res.message);
				}
			});
		},
		shipmentsOk(){
			const that = this;
			let url = 'api/store/v1/admin/order/shipments';
			let param = {
				orderId: this.shipmentsData[0].orderId,
				shippingCompName: this.shipmentsInfo,
				shippingSn: this.shipmentsSn
			};
			api.postRequest(url, param, res => {
				console.log(res.data.status);
				if (res.data.status == 200) {
					this.$message.loading({ content: '发货中~', key:'订单发货' });
					setTimeout(() => {
						this.$message.success({ content: '发货成功！订单状态已变更！', key:'订单发货', duration: 2 });
					}, 1000);
					this.getOrderListInfo();
					that.visible = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		synQuery(orderId){
			this.SynVisible = true;
			const that = this;
			let url = 'api/store/v1/guest/shipping/synQuery';
			let param = {
				orderId: orderId
			};
			api.postRequest(url, param, res => {
				
				console.log(res.data);
				if (res.data.status == 200) {
					this.datas = res.data.data.data;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		onSearch(value){
			const dataSource = express.data2;
			var arr = [];
			dataSource.forEach((item, index, array) => {
				if(item.match(value) != null){
					arr.push(item);
				}
			});
			this.express = arr;
		},
		showDeleteConfirm(orderSn) {
			this.$confirm({
				title: "删除订单",
				content: '删除订单：'+orderSn + '？',
				okText: '删除',
				okType: 'danger',
				cancelText: '取消',
				onOk() {
				  console.log('OK');
				},
				onCancel() {
				  console.log('Cancel');
				},
			});
		},
		shipments(order){
			console.log(order)
			this.visible = true;
			this.shipmentsData = [];
			this.shipmentsData.push(order)
		},
		searchHandle(){
			this.getOrderListInfo();
		},
		handleOk(){
			if(this.shipmentsInfo == ''
			|| this.shipmentsSn == ''){
				this.$message.warning("请输入配送方式和物流单号")
				return;
			}
			this.shipmentsOk();
			this.shipmentsInfo = '';
			this.shipmentsSn = '';
		},
		handleTableChange(pagination, filters, sorter) {
			console.log(pagination);
			this.pagination = pagination;
			this.page = this.pagination.current - 1;
			this.getOrderListInfo();
		},
		onChange(value) {
			console.log(value);
		},
		handleChange(value) {
			this.orderStatus = value.key;
			console.log(value);
		},
		resetHandle(){
			this.phone = '';
			this.orderStatus = 'all';
			this.createTime = undefined;
			this.orderSn = '';
			this.orderKey = { key: 'all' }
		},
		orderDetail(id) {
			let routeUrl = this.$router.resolve({
				path: '/orderDetail',
				query: { id: id }
			});
			window.open(routeUrl.href, '_blank');
		},
		shipModeTable(){
			let routeUrl = this.$router.resolve({
				path: '/shipTable'
			});
			window.open(routeUrl.href, '_blank');
		},
		moneyHandleOk(orderId){
			const that = this;
			let url = 'api/store/v1/admin/order/modifyOrderMoney';
			let param = {
				orderId: this.orderId,
				orderMoney:this.orderMoney*100
			};
			api.postRequest(url, param, res => {
				console.log(res.data.status);
				if (res.data.status == 200) {
					that.$message.success("修改成功！")
					that.moneyVisible = false;
					that.getOrderListInfo()
				} else {
					that.$message.error(res.data.message);
				}
			});
			
		},
		showMoneyModle(orderMoney,orderId){
			this.moneyVisible = true;
			this.orderMoney = orderMoney;
			this.orderId = orderId;
		}
	}
};
</script>
<style scoped>
.title {
	border: 2px solid gainsboro;
	margin-bottom: 30px;
	margin-top: 25px;
	border-radius: 5px;
	height: 145px;
}

.search{
	margin-left: 70px;
}
.search input{
	width: 200px;
	margin-top: 25px;
}
</style>
